var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2854 0.142578H0.142578V25.8569C0.142578 31.5397 4.74544 36.1426 10.4283 36.1426H25.8569C31.5397 36.1426 36.1426 31.5397 36.1426 25.8569V18.1426H41.2854C44.1397 18.1426 46.4283 15.8283 46.4283 12.9997V5.28544C46.4283 2.43115 44.1397 0.142578 41.2854 0.142578ZM41.2854 12.9997H36.1426V5.28544H41.2854V12.9997ZM0.142578 41.2854H41.2854V46.4283H0.142578V41.2854Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCup);
export default __webpack_public_path__ + "static/media/icon_cup.2004eaefbfa2a51173abfee78c225daf.svg";
export { ForwardRef as ReactComponent };